import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { COLLAPSIBLE_CONFIRMATION_TYPES } from './chatMessageContentTypes';
const intentToContent = (intent)=>{
    switch(intent.kind){
        case 'prompt':
            return intent.intentHint != null ? {
                type: 'prompt',
                text: intent.text,
                intentHint: intent.intentHint
            } : {
                type: 'prompt',
                text: intent.text
            };
        case 'apply':
            return {
                type: 'apply',
                messageId: intent.messageId,
                selectedItemIds: intent.selectedItemIds
            };
        case 'dismiss':
            return {
                type: 'dismiss',
                messageId: intent.messageId
            };
        case 'skip':
            return {
                type: 'skip',
                messageId: intent.messageId
            };
        case 'skipTheRest':
            return {
                type: 'skip-the-rest',
                messageId: intent.messageId
            };
        case 'listSelectClick':
            return {
                type: 'list-select-click',
                messageId: intent.messageId,
                itemId: intent.itemId,
                label: intent.label
            };
        case 'fileUploaded':
            return {
                type: 'file-uploaded',
                fileId: intent.fileId,
                fileName: intent.fileName,
                text: intent.text
            };
    }
};
const isAgreementFilterUpdate = (filterUpdate)=>'type' in filterUpdate && filterUpdate.type === 'agreements';
const withoutSurfaceStamp = (_0)=>{
    let { type: _type } = _0, filter = _object_without_properties(_0, [
        "type"
    ]);
    return filter;
};
export class ChatMessageModel {
    static fromDTO(dto) {
        return new ChatMessageModel(dto);
    }
    static fromIntent(intent, params) {
        return new ChatMessageModel({
            id: params.id,
            role: 'user',
            timestamp: params.now.toISOString(),
            content: intentToContent(intent)
        });
    }
    id() {
        return this.dto.id;
    }
    timestamp() {
        return this.dto.timestamp;
    }
    isUser() {
        return this.dto.role === 'user';
    }
    isAssistant() {
        return this.dto.role === 'assistant';
    }
    assistantContent() {
        return this.dto.role === 'assistant' ? this.dto.content : null;
    }
    assistantContentType() {
        return this.dto.role === 'assistant' ? this.dto.content.type : null;
    }
    appliedIds() {
        var _this_dto_content_appliedIds;
        if (this.dto.role !== 'assistant' || this.dto.content.type !== 'bulk-applied') return null;
        return (_this_dto_content_appliedIds = this.dto.content.appliedIds) !== null && _this_dto_content_appliedIds !== void 0 ? _this_dto_content_appliedIds : [];
    }
    revertedItemIds() {
        return this.dto.role === 'assistant' && this.dto.content.type === 'reverted' ? this.dto.content.revertedItemIds : null;
    }
    userContent() {
        return this.dto.role === 'user' ? this.dto.content : null;
    }
    persistedFilterUpdate() {
        const filterUpdate = this.persistedConversationFilterUpdate();
        return filterUpdate == null || isAgreementFilterUpdate(filterUpdate) ? null : filterUpdate;
    }
    persistedAgreementFilterUpdate() {
        const filterUpdate = this.persistedConversationFilterUpdate();
        return filterUpdate != null && isAgreementFilterUpdate(filterUpdate) ? withoutSurfaceStamp(filterUpdate) : null;
    }
    persistedConversationFilterUpdate() {
        var _content_filterUpdate;
        if (this.dto.role !== 'assistant') return null;
        const content = this.dto.content;
        if (content.type !== 'chat-text' && content.type !== 'bulk-confirmation' && content.type !== 'sequenced-confirmation') return null;
        return (_content_filterUpdate = content.filterUpdate) !== null && _content_filterUpdate !== void 0 ? _content_filterUpdate : null;
    }
    persistedSelectionUpdate() {
        var _content_selectionUpdate;
        if (this.dto.role !== 'assistant') return null;
        const content = this.dto.content;
        if (content.type !== 'chat-text' && content.type !== 'bulk-confirmation' && content.type !== 'sequenced-confirmation') {
            return null;
        }
        return (_content_selectionUpdate = content.selectionUpdate) !== null && _content_selectionUpdate !== void 0 ? _content_selectionUpdate : null;
    }
    isCollapsibleConfirmation() {
        return this.dto.role === 'assistant' && COLLAPSIBLE_CONFIRMATION_TYPES.has(this.dto.content.type);
    }
    isEnrichable(enrichableTypes) {
        return this.dto.role === 'assistant' && enrichableTypes.some((type)=>type === this.dto.content.type);
    }
    withEnrichedContent(patch) {
        if (this.dto.role !== 'assistant') return this;
        const content = this.dto.content;
        if (content.type !== 'applied' && content.type !== 'dismissed' && content.type !== 'bulk-applied') {
            return this;
        }
        return new ChatMessageModel(_object_spread_props(_object_spread({}, this.dto), {
            content: _object_spread({}, content, patch)
        }));
    }
    toUserAction() {
        if (this.dto.role !== 'user') return null;
        const content = this.dto.content;
        if (content.type === 'apply') {
            return {
                kind: 'apply',
                messageId: content.messageId,
                selectedItemIds: content.selectedItemIds
            };
        }
        if (content.type === 'dismiss') {
            return {
                kind: 'dismiss',
                messageId: content.messageId
            };
        }
        if (content.type === 'prompt') {
            return {
                kind: 'prompt',
                text: content.text
            };
        }
        return null;
    }
    toWirePayload() {
        const content = this.userContent();
        if (content == null) throw new Error('toWirePayload called on a non-user message');
        return content;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
